import React from 'react';
import { StorageBrowser } from '@aws-amplify/ui-react-storage';
import { Box } from '@mui/material';

function MyStorageBrowser() {

  const location = {
    bucket: process.env.REACT_APP_RMSI_BUCKET,
    prefix: "",
    type: "BUCKET" as any,
    permissions: ["list", "get", "write", "delete"] as any,
  } as any;

  return (
    <Box style={{ width: '100%' }}>
      <StorageBrowser defaultValue={{ location }} />
    </Box>
  );

}

export default MyStorageBrowser;